import React, { ComponentType } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';
import { ConnectedFooter } from 'src/web/components/Marketing/Footer/connector';
import { HeroSpace } from './components/HeroSpace';
import { GlobalCommunity } from '../../components/Marketing/GlobalCommunity';
import { FormalEducation } from './components/FormalEducation';
import { CourseTypes } from './components/CourseTypes';
import { EngageAndLearn } from './components/EngageAndLearn';
import { WhatStudentSay } from './components/WhatStudentSay';
import { FeaturedCourses } from '../../components/Marketing/FeaturedCourses';
import { LeadingInstitutions } from '../../components/Marketing/LeadingInstitutions';
import { Button } from '../../components/Marketing/Button';
import { TopBar } from '../../components/Marketing/TopBar';
import { JoinOpenLearning } from '../../components/Marketing/JoinOpenLearning';
import image3 from './images/image3.png';
import { MarketingPageGlobalStyling } from '../../components/MarketingPageGlobalStyling/component';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../components/Style/breakpoints';
import { HomepageProps } from './types';
import { testimonials } from './testimonials';

const Container = styled(Flex)`
  flex-direction: column-reverse;
  margin-top: 40px;
  margin-bottom: 40px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    flex-direction: initial;
  }
`;

const ContainerInner = styled.div`
  max-width: 960px;
  width: 100%;
  flex-direction: row;
  display: flex;
  margin-bottom: 40px;
  @media only screen and (min-width: 960px) {
    padding: 12px;
    > div {
      width: 50%;
    }
    > img {
      width: 50%;
    }
    margin-bottom: 0px;
  }
  img {
    display: none;
    @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
      display: block;
    }
  }
`;

const ImageHolder = styled(Flex)`
  flex-direction: column;
  padding-left: 0px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    padding: 15px;
    width: 50%;
  }
  img {
    width: 100%;
    height: auto;
  }
`;

const SubContainer = styled(Flex)`
  flex-direction: column;
  padding: 15px;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: center;
    // padding-left: 30px;
    width: 50%;
  }
`;

const FeaturesCoursesContainer = styled(Flex)`
  max-width: 1020px;
  margin: 0 auto;
  width: 100%;
`;

const ButtonContainer = styled(Flex)`
  justify-content: center;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    justify-content: start;
  }
`;

const SectionLabel = styled(Box)({
  fontWeight: 900,
  fontSize: '14px',
  lineHeight: '130%',
  color: '#B0B6C2',
  paddingBottom: '12px',
});

const SectionHeading = styled(Box)({
  fontWeight: 900,
  fontSize: '36px',
  lineHeight: '120%',
  letterSpacing: '-0.01em',
  color: '#041416',
  paddingBottom: '24px',
});

const SectionDescription = styled(Box)({
  fontWeight: 'normal',
  fontSize: '16px',
  lineHeight: '140%',
  color: '#7C8788',
  paddingBottom: '24px',
});

export const Homepage: ComponentType<HomepageProps> = ({
  isLoggedIn,
  featuredCourses,
  featuredPartners,
}: HomepageProps) => (
  <>
    <MarketingPageGlobalStyling />
    {isLoggedIn ? null : <TopBar />}
    <HeroSpace CourseTypeButton={Button} />
    <GlobalCommunity />
    <FormalEducation />
    <CourseTypes />
    <EngageAndLearn />
    {/* TODO: This should be a component */}
    <Container>
      <ContainerInner>
        <SubContainer>
          <SectionLabel>INTERACTIVE AND SOCIAL</SectionLabel>
          <SectionHeading>
            Master skills through engaging group activities
          </SectionHeading>
          <SectionDescription>
            Leveraging decades of learning sciences research, our platform is
            purpose built for delivering social, constructive and outcome-based
            learning experiences.
          </SectionDescription>
          <ButtonContainer>
            <Button
              variant="primary"
              action={{
                kind: 'external_link',
                value:
                  'https://solutions.openlearning.com/learning-philosophy/',
                target: '_blank',
              }}
            >
              Learn more about our philosophy
            </Button>
          </ButtonContainer>
        </SubContainer>
        <ImageHolder>
          <img alt="" src={image3} />
        </ImageHolder>
      </ContainerInner>
    </Container>
    <WhatStudentSay testimonials={testimonials} />
    <FeaturesCoursesContainer>
      <FeaturedCourses header="Courses" courses={featuredCourses} />
    </FeaturesCoursesContainer>
    <LeadingInstitutions
      title="Featured partner institutions"
      logos={featuredPartners}
    />
    <JoinOpenLearning
      header="Join over 2,700,000 students worldwide"
      buttonText="Browse our courses"
      buttonAction={{
        kind: 'internal_link',
        value: {
          link: {
            to: {
              type: 'ROUTE_COURSES',
            },
          },
        },
      }}
    />
    {isLoggedIn ? null : <ConnectedFooter />}
  </>
);
